import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "canvas-tool"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  key: 0,
  class: "more-tool"
};
var _hoisted_4 = {
  key: 1,
  class: "divider"
};
var _hoisted_5 = {
  key: 1
};
import SizeThickness from './SizeThickness';
import ColorSelect from './ColorSelect';

/* 工具 */
import { ref, watch, computed } from 'vue';
import { TOOL_MAP } from './const';
import { DropdownItem } from 'tdesign-vue-next';

/* 变量 */

export default {
  __name: 'index',
  props: {
    tools: {
      type: Array,
      default: function _default() {
        return ['brush', 'rubber', 'text', 'note', 'clean', 'save', 'save-course'];
      }
    }
  },
  emits: ['change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 组件 */
    var props = __props;
    var emit = __emit;
    var toolList = ref([]); // 所展示的工具列表
    var toolType = ref(''); // 当前选中的工具
    var thickness = ref(0); // 当前选择粗细
    var color = ref(''); // 当前选择颜色

    /* 计算属性 */
    var showSizeThickness = computed(function () {
      var arr = ['brush', 'rubber', 'text'];
      return arr.includes(toolType.value);
    });
    var showColorSelect = computed(function () {
      var arr = ['brush', 'text'];
      return arr.includes(toolType.value);
    });

    /* 监听 */
    watch(function () {
      return props.tools;
    }, function (tools) {
      var list = TOOL_MAP.filter(function (e) {
        return tools.includes(e.tool);
      });
      toolList.value = list.map(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          isCheck: false
        });
      });
    }, {
      immediate: true,
      deep: true
    });

    /* 事件 */
    // 切换工具
    var toolChange = function toolChange(item) {
      // 切换选择状态
      toolList.value.forEach(function (e) {
        if (e.tool !== item.tool) {
          e.isCheck = false;
        }
      });
      if (item.canCheck) {
        item.isCheck = !item.isCheck;
      }

      // 处理悬浮工具值
      thickness.value = 0;
      color.value = '';
      if (item.isCheck) {
        toolType.value = item.tool;
        if (item.tool === 'brush') {
          thickness.value = 2;
          color.value = '#DE3F3F';
        } else if (item.tool === 'rubber') {
          thickness.value = 6;
        } else if (item.tool === 'text') {
          thickness.value = 14;
          color.value = '#DE3F3F';
        }
      } else {
        var arr = ['clean', 'save', 'save-course'];
        if (arr.includes(item.tool)) {
          toolType.value = item.tool;
        } else {
          toolType.value = '';
        }
      }
      handleEmit();
    };

    // 发射信息
    var handleEmit = function handleEmit() {
      emit('change', {
        tool: toolType.value,
        thickness: thickness.value,
        color: color.value
      });
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_popup = _resolveComponent("t-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toolList.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.tool,
          class: _normalizeClass(["tool-item", {
            'tool-active': item.isCheck
          }]),
          onClick: function onClick($event) {
            return toolChange(item);
          }
        }, [_createVNode(_component_t_popup, {
          destroyOnClose: ""
        }, {
          content: _withCtx(function () {
            return [item.isCheck ? (_openBlock(), _createElementBlock("div", _hoisted_3, [showSizeThickness.value ? (_openBlock(), _createBlock(_unref(SizeThickness), {
              key: 0,
              modelValue: thickness.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                return thickness.value = $event;
              }),
              type: toolType.value,
              onChange: handleEmit
            }, null, 8, ["modelValue", "type"])) : _createCommentVNode("", true), showColorSelect.value ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : _createCommentVNode("", true), showColorSelect.value ? (_openBlock(), _createBlock(_unref(ColorSelect), {
              key: 2,
              modelValue: color.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                return color.value = $event;
              }),
              onChange: handleEmit
            }, null, 8, ["modelValue"])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.name), 1))];
          }),
          default: _withCtx(function () {
            return [_createVNode(_component_svg_icon, {
              class: "icon",
              name: item.icon,
              size: "24"
            }, null, 8, ["name"])];
          }),
          _: 2
        }, 1024)], 10, _hoisted_2);
      }), 128))]);
    };
  }
};